module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      position: 'relative',
      paddingTop: ((((1 / _vm.info.aspect) * 100)) + "%")
    })
  }, [(_vm.refObject.$isInit) ? _c('PlayerFrame', {
    attrs: {
      "refObject": _vm.refObject,
      "info": _vm.info
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.refObject.$isInit) ? _c('PosterFrame', {
    attrs: {
      "refObject": _vm.refObject,
      "info": _vm.info,
      "onPlay": _vm.handlePlay
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60dfc97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 178
// module chunks = 0 1